import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 固定資産増減合計表帳票種類 */
enum LeaseIncrDecrTableReportType {
  details = '1',
  summary = '2',
}

const nameConfig = {
  details: new Map([[Locale.ja, '固定資産増減明細表']]),
  summary: new Map([[Locale.ja, '固定資産増減合計表']]),
};

const toEnum = rawValueToEnum(LeaseIncrDecrTableReportType, LeaseIncrDecrTableReportType.summary);
const toDisplay = enumToName(LeaseIncrDecrTableReportType, nameConfig);
const toDisplayWithPrefix = enumToName(LeaseIncrDecrTableReportType, nameConfig, { prefix: true });

export const leaseIncrDecrTableReportType = {
  enum: LeaseIncrDecrTableReportType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LeaseIncrDecrTableReportType };
